export const downloadCsvFile = (
  content: string,
  fileName: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      const csvBlob = new Blob([content], { type: "text/csv" });
      const csvUrl = URL.createObjectURL(csvBlob);

      const link = document.createElement("a");
      link.href = csvUrl;
      link.download = fileName;
      link.target = "_blank";
      link.click();

      URL.revokeObjectURL(csvUrl);

      resolve();
    } catch (e) {
      reject(e);
    }
  });
};
